import { Utils } from '../utils';

let currentRatio = 1.7;
function calculateSize(ratio = currentRatio, marginX = 0, marginY = 0) {
  const pageW = document.documentElement.clientWidth - marginX;
  const pageH = document.documentElement.clientHeight - marginY;
  let width;
  let height;
  let fontSize;

  if (pageW / pageH <= ratio) {
    // 上下黑边
    width = pageW;
    height = pageW / ratio;
    fontSize = pageW / 20;
  } else {
    width = pageH * ratio;
    height = pageH;
    fontSize = (pageH * ratio) / 20;
  }

  Utils.contWidth = width;
  Utils.contHeight = height;
  return {
    width: `${width}px`,
    height: `${height}px`,
    fontSize: `${fontSize}px`,
  };
}
export default {
  bind(element: HTMLElement, bindings: any) {
    const el = element;
    const binding = bindings;
    el.style.cssText = 'position: absolute;margin: auto;top: 0;bottom: 0;left: 0;right: 0;';
    const { ratio, marginX, marginY } = binding.value;
    currentRatio = ratio;
    binding.updateSize = () => {
      const { height, width, fontSize } = calculateSize(currentRatio, marginX, marginY);
      const doc = document.documentElement;
      doc.style.fontSize = fontSize;
      el.style.height = height;
      el.style.width = width;
    };
    binding.updateSize();
    window.addEventListener('resize', binding.updateSize);
  },
  update(element: HTMLElement, bindings: any) {
    const binding = bindings;
    const el = element;
    const { ratio, marginX, marginY } = binding.value;
    currentRatio = ratio;
    const { height, width, fontSize } = calculateSize(ratio, marginX, marginY);
    const doc = document.documentElement;
    doc.style.fontSize = fontSize;
    el.style.height = height;
    el.style.width = width;
  },
  unbind(element: HTMLElement, bindings: any) {
    const binding = bindings;
    window.removeEventListener('resize', binding.updateSize);
  },
};
